import React from 'react';
import { connect } from 'react-redux';
import { getEnumName, getJobDescriptionNames } from 'helpers/enums';

const PostDetailsPanel = (props) => {
  const { details, enums } = props;
  const { eventSettings, sports, settingDetails, jobDescriptions } = enums;
  const { eventSettingId, sportId, settingDetailId, jobDescriptionIds } = details;
  const eventSetting = getEnumName(eventSettings, eventSettingId);
  const settingDetail = getEnumName(settingDetails, settingDetailId);
  const sportType = getEnumName(sports, sportId);
  const jobDescriptionNames = getJobDescriptionNames(jobDescriptions, jobDescriptionIds);

  const fileReader = (() => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      props.onFieldChange('imagePreview', reader.result);
    });
    return reader;
  })();

  const onEventImageChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    const target = event.target;
    const file = target.files[0];
    fileReader.readAsDataURL(file);
    props.onFieldChange('eventLogo', file);
  };

  return (
    <div className="post-details-panel">
      <div className="event-logo-preview image-preview col-sm-2 col-lg-1">
        <input
          className="custom-file-input event-logo-input"
          type="file"
          name="event_logo"
          accept="image/*"
          onChange={onEventImageChange}
        />
        <img
          alt="event-logo"
          className="image-preview"
          src={details.imagePreview || require('styles/EventLogoPlaceholder.png')}
        />
        {!details.imagePreview && <span className="image-preview-text gotham-medium-font">Add event logo</span>}
      </div>
      <div className="event-details">
        <div className="event-title gotham-bold-font">{details.title}</div>
        <div>
          {`${eventSetting} / ${settingDetail}`}
          {eventSetting === 'Sports' && ` / ${sportType}`}
        </div>
        <div>{jobDescriptionNames}</div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ enums: state.enums });

export default connect(mapStateToProps)(PostDetailsPanel);
